import Vue from "vue";
import api from "./api";

const SET_ACTIVE_IMAGE = "SET_ACTIVE_IMAGE";
const TRANSFER_IMAGE = "TRANSFER_IMAGE";
const UPDATE_IMAGE = "UPDATE_IMAGE";

const namespaced = true;

const state = {
  active: _getImage(),
  cache: _getImage(),
};

function _getImage() {
  return JSON.parse(localStorage.getItem("image") || "{}");
}

const mutations = {
  SET_ACTIVE_IMAGE(state, data) {
    state.active = data || {};
    state.cache = { ...data };

    localStorage.setItem("image", JSON.stringify(state.active));
  },
  TRANSFER_IMAGE(state) {
    state.cache = { ...state.active };
    localStorage.setItem("image", JSON.stringify(state.cache));
  },
  UPDATE_IMAGE(state, { key, val }) {
    Vue.set(state.active, key, val);
  },
};

const actions = {
  setImage({ commit }, data) {
    commit(SET_ACTIVE_IMAGE, data);
  },
  setUpdate({ commit }, { key, val }) {
    commit(UPDATE_IMAGE, { key, val });
  },

  getImageList({ commit }, data) {
    return api
      .getImageList(data)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  getImageCount({ commit }, data) {
    return api
      .getImageCount(data)
      .then((data) => Object.values(data.data)[0])
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  getOneImage({ commit }, image_id) {
    return api
      .getOneImage(image_id)
      .then((data) => {
        commit(SET_ACTIVE_IMAGE, data.data);
        return data.data;
      })
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  addImage({ commit }, data) {
    return api
      .addImage(data)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  updateImage({ commit, state }, data) {
    var id = data ? data.image_id : state.active.id;
    var update = data ? data.data : state.active;

    return api
      .updateImage(id, update, state.cache)
      .then((v) => {
        commit(TRANSFER_IMAGE);
      })
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  deleteImage({ commit, state }, image_id) {
    var delete_id = image_id || state.active.id;
    return api
      .deleteImage(delete_id)
      .then((v) => commit(SET_ACTIVE_IMAGE, {}))
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  checkImageInQuote({ commit }, image_id) {
    return api
      .checkImageInQuote(image_id)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
};

const getters = {
  id: (state) => (state.active ? state.active.id : ""),
  active: (state) => state.active || {},
  cache: (state) => state.cache || {},

  hasChanges: (state) => {
    let current = JSON.stringify(state.active);
    let cached = JSON.stringify(state.cache);
    if (current === cached) return false;
    return true;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
